const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceCheckoutEventGA4 } = require('../models/ecommerceCheckoutEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * CHECKOUT EVENTS                                                            *
 * - View Cart                                                                *
 * - Edit summary                                                             *
 * - Payment Info                                                             *
 * - Starting process                                                         *
 * - Order confirmed                                                          *
 * - Shipping Info                                                            *
 * - Form Field Error                                                         *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // View Cart [step 1]
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutCartViewed, () => {
      pushEvent(
        createEcommerceCheckoutEventGA4('view_cart'),
      );
    },
  );

  // Edit is clicked in summary
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutOrderSummaryEdited, (payload) => {
      pushEvent(
        createCustomEventGA4('order_summary', [
          ['action', 'edit'],
          ['item', payload.item],
        ]),
      );
    },
  );

  // Payment Info [step 4]
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutPaymentInfoAdded, (payload) => {
      pushEvent(
        createEcommerceCheckoutEventGA4('add_payment_info', payload.order),
      );
    },
  );

  // Starting process [step 2]
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutProcessStarted, (payload) => {
      pushEvent(
        createEcommerceCheckoutEventGA4('begin_checkout', payload?.order),
      );
    },
  );

  // Order confirmed
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutPurchaseConfirmed, (payload) => {
      pushEvent(
        createEcommerceCheckoutEventGA4('purchase', payload.order),
      );
    },
  );

  // Shipping Info [step 3]
  analyticsEventCenter.subscribe(
    ANALYTICS_EVENTS.checkoutShippingInfoAdded, (payload) => {
      pushEvent(
        createEcommerceCheckoutEventGA4('add_shipping_info', payload.order),
      );
    },
  );

  // Form Field Error
  analyticsEventCenter.subscribe([
    ANALYTICS_EVENTS.formErrorShown,
    ANALYTICS_EVENTS.formFieldErrorShown,
  ],
  ({
    errorMessage,
    formName,
    pageType,
  }) => {
    const pageTypes = ANALYTICS_EVENTS.PAYLOADS.formFieldErrorShown.pageType;
    const typeByPageTypeAndFormName = {
      [pageTypes.checkout]: {
        dwfrm_shipping: 'shipping', // shippingForm in Checkout
        'guest-form': 'guest', // guestForm in Checkout
        'login-form': 'login', // loginForm in Checkout
        dwfrm_billing: 'payment', // paymentForm in Checkout
        'purchase-error': 'purchase', // order attemp in Checkout
      },
    };
    const type = typeByPageTypeAndFormName[pageType]?.[formName];
    if (type) {
      pushEvent(
        createCustomEventGA4('checkout_error', [
          ['type', type],
          ['message', errorMessage],
        ]),
      );
    }
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
